/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: dropdown-list-component.ts
 *
 * Created by kyang on 2019-11-05.
 */

function DropdownListController (
    this: JS5Object,
    _: JS5Object,
    $scope: JS5Object,
    DropdownService: JS5Object,
    Rx: JS5Object,
) {

    //===================//
    // Template Response //
    //===================//

    this.getItemLabel = (item: JS5Object) => {
        return DropdownService.getLabel(this.dropdownConfig, item);
    };

    this.isItemDisabled = (item: JS5Object) => {
        return DropdownService.isItemDisabled(this.dropdownConfig, item);
    };

    this.isItemSelected = (item: JS5Object) => {
        return this.selectService.isItemSelected(this.dropdownConfig, item);
    };

    this.areAllItemsSelected = () => {
        return this.selectService.areAllEnabledItemsSelected(this.dropdownConfig);
    };

    this.onItemClicked = (item: JS5Object) => {
        if (this.dropdownConfig.isMultiSelect) {
            this.selectService.toggleItemSelection(this.dropdownConfig, item);
        } else {
            this.selectService.setSelection(this.dropdownConfig, item);
        }
    };

    this.onSelectAllClicked = () => {
        if (this.areAllItemsSelected()) {
            this.selectService.setSelection(this.dropdownConfig, []);
        } else {
            this.selectService.setSelection(this.dropdownConfig, this.dropdownConfig.collection);
        }
    };

    this.shouldShowItem = (item: JS5Object) => {
        let label = DropdownService.getLabel(this.dropdownConfig, item).toUpperCase();
        return label.includes(this.currentFilter);
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$onChanges = () => {
        if (this.filterObservable) {
            this.filterObservable.onNext(this.dropdownConfig.filter);
        }
    };

    this.$onInit = () => {
        this.currentFilter = this.dropdownConfig.filter.toUpperCase();
        this.filterObservable = new Rx.BehaviorSubject(this.currentFilter.toUpperCase());
        this.filterObservable
            .distinctUntilChanged()
            .debounce(100)
            .subscribeOnNext((newFilter: string) => {
                $scope.$apply(() => this.currentFilter = newFilter.toUpperCase());
            });
    };
}

angular.module('prism-ui.components').component(
    'dropdownList',
    {
        bindings: {
            selectService: '<',
            dropdownConfig: '<',

            isDisabled: '<ngDisabled',
            enableSelectAll: '<?',
            maxHeightStyle: '<?',
        },
        transclude: {
            'dropdown-option': '?dropdown-option'
        },
        controller: DropdownListController,
        templateUrl: 'components/visual/dropdown/dropdownList/dropdown-list-template.html'
    });
